import { createFileRoute } from '@tanstack/react-router'
import { OptOutPage } from '@/pages/OptOutPage'

const RouteComponent = () => {
  const { token } = Route.useParams()
  return <OptOutPage token={token} />
}

// Route publique, sans requireGuest : le lien doit marcher que la personne
// soit connectée ou non.
export const Route = createFileRoute('/opt-out/$token')({
  component: RouteComponent,
})
